import React, { useEffect, useRef, useState } from "react";
import { useFormik } from "formik";
import Swal from "sweetalert2";
import { useNavigate } from "react-router-dom";
import Breadcrums from "../../common/breadcrumbs";
import { useTranslation } from "react-i18next";
import {
  EMAIL_REGEX,
  INPUT_LENGTH_15,
  PHONE_NO_LENGTH,
  ROLE,
  SWAL_SETTINGS,
  TEXTAREA_MAX_LENGTH,
} from "../../../../utils/Constants";
import {
  blockInvalidChar,
  DT,
  globalLoader,
  handleServerValidations,
} from "../../../../utils/commonfunction";
import * as Yup from "yup";
import CustomError from "../../../../utils/customError";
import { Add } from "../../services/doctor.services";
import { GetAllCenters } from "../../services/usermgmt.services";
import { cuisineOptions } from "../../../../utils/Constants";
import { TagPicker, Tooltip, Whisper } from "rsuite";
import PhoneInput from "../../../../utils/PhoneInput";
import { PHONE_VALIDATION } from "../../../../utils/commonValidations";
import trash from "../../../../assets/center/images/trash.svg";
import { ACTIVE, DEACTIVE, DOCTOR_SPECIALIZATION, GENDER, LOADER_TIMEOUT_TIME, SORT_A, SORT_D } from "../../../../utils/Constants";
import { capitalizeFirstLetter, formatDateFromTime, formatePickerDate, getColorType, getDateWithTime, getDayDiff, handleOffcanvasScroll, TrimText, useDebouncing } from "../../../../utils/commonfunction";
import { CATEGORIES_TAX_TYPES } from "../../../../utils/Constants";
import { ReactSortable } from "react-sortablejs";
import { Link, useLocation, useParams } from "react-router-dom";
import { DatePicker, Drawer } from "rsuite";
import Skeleton from "react-loading-skeleton";
import CustomPagination from "../../../admin/common/custompagination";
import DefaultProfileImg from '../../../../assets/center/images/default_user_profile.png';
import { SpecializationList } from "../../services/coach-specialization.services";
import CustomMultiSelect from "../../shared/CustomMultiSelect";
import Select from 'react-select';


const UsersAdd = (props) => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const [submitted, setSubmitted] = useState(false);
  const [previewimage, setPreviewImage] = useState("");
  const [centers, setCenters] = useState([]);
  const fileSelectInput = useRef();
  const [specialization, setSpecialization] = useState([]);

  const breadcrumbs = [
    { title: t("admin.cafes.link_dashboard"), url: "/admin/dashboard/1" },
    {
      title: t("Doctor Management"),
      url: "/admin/doctor-management/doctor/list/1",
    },
    { title: t("admin.cafes.link_add"), url: "" },
  ];

  useEffect(() => {
    GetAllCenters()
      .then((data) => {
        setCenters(data && data.data ? data.data : []);
      })
      .catch((error) => {
        console.log("error ====> ", error);
      });
  }, []);

  useEffect(() => {
    SpecializationList(ROLE.SUPER_ADMIN)
      .then((data) => {
        setSpecialization(data && data.data ? data.data.list : []);
      })
      .catch((error) => {
        console.log("error ====> ", error);
      });
  }, []);

  const handleFilePreview = (file) => {
    if (typeof file === "string") {
      return file;
    } else {
      return URL.createObjectURL(file);
    }
  };

  const handleFileSelection = (event, form) => {
    if (event.target.files.length) {
      form.setFieldValue("profile_image", event.target.files[0]);
    }
  };

  const handleStartTimeChange = (e) => {
    addForm.setFieldTouched('startTime', true);
    const match = String(e).match(/\d{2}:\d{2}(?::\d{2})?/);
    if (match && match[0]) {
      const parts = match[0].split(':');
      const hours = parts[0];
      const minutes = parts[1];
      const seconds = parts[2] || '00';
      addForm.setFieldValue('startTime', `${hours}:${minutes}:${seconds}`);
    }
  };

  const handleEndTimeChange = (e) => {
    addForm.setFieldTouched('endTime', true);
    const match = String(e).match(/\d{2}:\d{2}(?::\d{2})?/);
    if (match && match[0]) {
      const parts = match[0].split(':');
      const hours = parts[0];
      const minutes = parts[1];
      const seconds = parts[2] || '00';
      addForm.setFieldValue('endTime', `${hours}:${minutes}:${seconds}`);
    }
  };

  const validationSchema = Yup.object().shape({
    first_name: Yup.string().trim().max(50, "First name name must not be more than 50 characters.").required("First name is required"),
    last_name: Yup.string().trim().max(50, "Last name name must not be more than 50 characters.").required("Last name is required"),
    email: Yup.string()
      .trim()
      .required("admin.cafes.label_email_required_error")
      .email("admin.cafes.label_email_invalid_format_error")
      .matches(
        /^(?!\.)(?!.*\.\.)[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/,
        "admin.cafes.label_email_invalid_format_error"
      ),
    gender: Yup.string()
      .trim()
      .required("Gender is required"),
    consultation_charge: Yup.number()
      .required("Consultation charge is required")
      .integer("Consultation charge must be an integer")
      .min(0, "Consultation charge cannot be negative")
      .max(9999, "Consultation charge cannot be more than 4 digits"),
    experience_years: Yup.number()
      .required("Experience(years) is required")
      .integer("Experience(years) must be an integer")
      .min(0, "Experience(years) cannot be negative")
      .max(9999, "Experience(years) cannot be more than 4 digits"),
    experience_months: Yup.number()
      .required("Experience(months) is required")
      .integer("Experience(months) must be an integer")
      .min(0, "Experience(months) cannot be negative")
      .max(9999, "Experience(months) cannot be more than 4 digits"),
    dob: Yup.string().required("DOB is required"),
    specialization: Yup.mixed()
      .required("Specialization is required")
      .test("no-spaces", "Specialization is required", (value) => {
        return String(value).trim().length > 0;
      }),
    center: Yup.string()
      .trim()
      .required("Centre is required"),
    startTime: Yup.string()
      .trim()
      .required("Start time is required"),
    endTime: Yup.string()
      .trim()
      .required("End time is required")
      .test('is-greater-than-startTime', 'End time must be greater than start time', function (value) {
        const { startTime } = this.parent;

        const start = new Date(`1970-01-01T${startTime}`);
        const end = new Date(`1970-01-01T${value}`);
        return start <= end;
      }),
    phone_number: PHONE_VALIDATION,
    // address: Yup.string().trim().max(TEXTAREA_MAX_LENGTH, "Location must not be more than 150 characters.").required("Location is required"),
    profile_image: Yup.mixed()
      .nullable()
      .test(
        'fileType',
        'admin.cafes.supported_file_error',
        value => !value || ['image/jpg', 'image/jpeg', 'image/png', 'image/webp', 'image/gif'].includes(value.type)
      )
      .test(
        'fileSize',
        'admin.cafes.image_max_size_error',
        value => !value || value.size <= 1.5 * 1024 * 1024
      )
      .test(
        'validImage',
        'Upload a valid image',
        value =>
          new Promise(resolve => {
            if (!value || typeof value === 'string') return resolve(true);

            const reader = new FileReader();
            reader.onload = () => {
              const img = new Image();
              img.onload = () => resolve(true);
              img.onerror = () => resolve(false);
              img.src = reader.result;
            };
            reader.onerror = () => resolve(false);
            reader.readAsDataURL(value);
          })
      ),
  });

  const addForm = useFormik({
    enableReinitialize: true,
    initialValues: {
      profile_image: "",
      document: "",
      first_name: "",
      last_name: "",
      email: "",
      dob: "",
      gender: "",
      specialization: [],
      center: '',
      phone_number: "",
      startTime: "",
      endTime: "",
      consultation_charge: "",
      experience_months: "",
      experience_years: "",
      qualification1: "",
      qualification2: "",
      institute1: "",
      institute2: ""
    },
    validateOnBlur: false,
    validationSchema: validationSchema,
    onSubmit: (values, { setSubmitting, resetForm }) => {
      globalLoader(true);
      setSubmitted(true);
      let formData = new FormData();
      formData.append("first_name", values.first_name);
      formData.append("last_name", values.last_name);
      formData.append("email", values.email);
      formData.append("phone_number", values.phone_number);
      formData.append("dob", values.dob);
      formData.append("gender", values.gender);
      formData.append("specialisation", JSON.stringify(values.specialization));
      formData.append("center_id", values.center);
      formData.append("start_available_time", values.startTime);
      formData.append("end_available_time", values.endTime);
      if (values.profile_image) {
        formData.append("profile_image", values.profile_image);
      }
      if (values.document) {
        formData.append("document", values.document);
      }
      formData.append("consultation_charge", values.consultation_charge);
      formData.append("experience_months", values.experience_months);
      formData.append("experience_years", values.experience_years);
      formData.append("qualification1", values.qualification1);
      formData.append("qualification2", values.qualification2);
      formData.append("institute1", values.institute1);
      formData.append("institute2", values.institute2);

      Add(formData)
        .then((response) => {
          setSubmitting(false);
          if (response.success) {
            Swal.fire({
              icon: "success",
              text: response.message,
              ...SWAL_SETTINGS,
            });
            globalLoader(false);
            resetForm({ values: "" });
            navigate(`/admin/doctor-management/doctor/list/1`);
          } else {
            Swal.fire({
              icon: "error",
              text: handleServerValidations(response),
              ...SWAL_SETTINGS,
            });
            globalLoader(false);
            setSubmitted(false);
          }
        })
        .catch((error) => {
          console.log("error ====> ", error);
        });
    },
  });

  const specializationData = specialization && specialization.map((item) => ({
    label: capitalizeFirstLetter(item?.title),
    value: item?._id
  }));

  const centerOptions = centers.map((item) => ({
    value: item._id,
    label: `${capitalizeFirstLetter(item.center_name)}${item.city ? ` (${capitalizeFirstLetter(item.city)})` : ''}`
  }));

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      <form onSubmit={addForm.handleSubmit}>
        <div className="row row-sm">
          <div className="col-lg-12 col-md-12 animation_fade">
            <div className="card custom-card">
              <div className="card-body">
                {/* <div>
                  <h6 className="main-content-label mb-3">
                    Add Doctor
                  </h6>
                </div> */}
                <div className="row row-sm">

                  {/* profile image */}
                  {/* <div className="profile-photo-upload mb-3" style={{ margin: "auto" }}>
                    <div className="avatar avatar-xl">
                      <img alt="profile_image" src={addForm?.values?.profile_image ? handleFilePreview(addForm?.values?.profile_image) : DefaultProfileImg} />
                    </div>
                    <button
                      className="cp e_none"
                      type="button"
                      onClick={() => {
                        fileSelectInput?.current?.click();
                      }}
                    >
                      <input ref={fileSelectInput} id="profile_image" name="profile_image" accept="image/*" type="file" onChange={(e) => handleFileSelection(e, addForm)} />
                      <i className="ti ti-upload"></i>
                    </button>
                  </div> */}
                  <div className="profile-photo-upload mb-3" style={{ margin: "auto" }}>
                    <div
                      className="avatar avatar-xl"
                      onClick={() => fileSelectInput?.current?.click()}
                      style={{
                        position: "relative",
                        width: "100px",
                        height: "100px",
                        overflow: "hidden",
                        borderRadius: "50%",
                        border: "1px solid rgb(175, 177, 178)",
                      }}
                    >
                      <img
                        alt="profile_image"
                        src={addForm?.values?.profile_image ? handleFilePreview(addForm?.values?.profile_image) : DefaultProfileImg}
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                        }}
                      />

                      {/* Upload Icon */}
                      <div
                        style={{
                          position: "absolute",
                          bottom: "2px",
                          right: "33px",
                          backgroundColor: "#fff",
                          borderRadius: "50%",
                          padding: "5px",
                          cursor: "pointer",
                          boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.2)",
                          width: "35px",
                          height: "30px"
                        }}
                      >
                        <i className="ti ti-upload d-flex justify-content-center" style={{ fontSize: "20px", height: "10px", color: "#007bff" }}></i> {/* Upload Icon */}
                      </div>
                    </div>
                    <button className="cp e_none" type="button" style={{ display: "none" }}>
                      <input
                        ref={fileSelectInput}
                        id="profile_image"
                        name="profile_image"
                        accept="image/*"
                        type="file"
                        onChange={(e) => handleFileSelection(e, addForm)}
                      />
                    </button>
                  </div>


                  <CustomError name="profile_image" form={addForm} className="text-danger text-left d-flex" />
                  {console.log(addForm.errors)}
                  {/* first name */}
                  <div className="col-md-6 text-center form-group">
                    <label htmlFor="name" className="text-left d-flex">
                      {t("center.staff.label_first_name")}:
                      <span className="requirestar">*</span>
                    </label>
                    <input
                      id="name"
                      type="text"
                      placeholder={t("center.staff.placeholder_first_name")}
                      name="first_name"
                      value={addForm?.values?.first_name}
                      onChange={addForm.handleChange}
                      onBlur={addForm.handleBlur}
                      className="form-control"
                    />
                    <span className="text-danger d-flex text-left">
                      {/* <CustomError shortCodes={[INPUT_LENGTH_15]} name="name" form={formik} /> */}
                      <CustomError name="first_name" form={addForm} className="text-danger" />
                    </span>
                  </div>

                  {/* last name */}
                  <div className="col-md-6 text-center form-group">
                    <label htmlFor="name" className="text-left d-flex">
                      {t("center.staff.label_last_name")}:
                      <span className="requirestar">*</span>
                    </label>
                    <input
                      id="name"
                      type="text"
                      placeholder={t("center.staff.placeholder_last_name")}
                      name="last_name"
                      value={addForm?.values?.last_name}
                      onChange={addForm.handleChange}
                      onBlur={addForm.handleBlur}
                      className="form-control"
                    />
                    <span className="text-danger d-flex text-left">
                      <CustomError name="last_name" form={addForm} className="text-danger" />
                    </span>
                  </div>

                  {/* email */}
                  <div className="col-lg-6 text-center form-group">
                    <label className="text-left d-flex">
                      {t("center.staff.label_email")}:
                      <span className="requirestar">*</span>
                    </label>
                    <input
                      type="email"
                      className="form-control"
                      placeholder={t("center.staff.placeholder_email_address")}
                      name="email"
                      value={addForm?.values?.email}
                      onChange={addForm.handleChange}
                      onBlur={addForm.handleBlur}
                    />
                    <span className="text-danger d-flex text-left">
                      <CustomError name="email" form={addForm} className="text-danger" />
                    </span>
                  </div>

                  {/* Phone Number */}
                  <div className="col-md-6 text-center form-group">
                    <label className="text-left d-flex">
                      Phone Number:
                      <span className="requirestar">*</span>
                    </label>
                    <PhoneInput
                      value={addForm?.values?.phone_number}
                      name={"phone_number"}
                      onChange={(e) => {
                        addForm.setFieldValue("phone_number", e?.phone_number);
                      }}
                      placeholder={t("center.staff.placeholder_contact_number")}
                      onBlur={addForm.handleBlur}
                    />
                    <span className="text-danger d-flex text-left">
                      <CustomError name="phone_number" form={addForm} className="text-danger" shortCodes={{ PHONE_MIN_LENGTH: PHONE_NO_LENGTH.min, PHONE_MAX_LENGTH: PHONE_NO_LENGTH.max }} />
                    </span>
                  </div>
                  {/* gender  */}
                  <div className="col-md-6 text-center form-group">
                    <label className="text-left d-flex">
                      {t("Gender")}:
                      <span className="requirestar">*</span>
                    </label>
                    <select className="form-control form-select cp" name='gender' value={addForm?.values?.gender} onChange={addForm.handleChange}>
                      <option value={""}>{t("Select")}</option>
                      {GENDER.map((item, index) => { return (<option key={index} value={item.value}>{item.label}</option>) })}
                    </select>
                    {addForm.touched.gender && addForm.errors.gender ? (
                      <div className="text-danger d-flex text-left">{t(addForm.errors.gender)}</div>
                    ) : null}
                  </div>
                  {/* dob */}
                  <div className="col-lg-6 text-center form-group">
                    <label className="text-left d-flex">
                      {t("DOB")}:
                      <span className="requirestar">*</span>
                    </label>
                    <DatePicker
                      oneTap={true}
                      classPrefix="restaurant"
                      placeholder={t("Enter DOB")}
                      placement="autoVertical"
                      format="dd.MM.yyyy"
                      cleanable={false}
                      editable={false}
                      name="dob"
                      onChange={(e) => {
                        addForm.setFieldTouched('dob', true);
                        addForm.setFieldValue("dob", e);
                      }}
                      value={new Date(addForm.values.dob) || new Date()}
                      onBlur={addForm.handleBlur}
                      shouldDisableDate={(date) => {
                        const today = new Date();
                        today.setHours(0, 0, 0, 0);

                        const minDate = new Date();
                        minDate.setFullYear(today.getFullYear() - 18);
                        minDate.setHours(0, 0, 0, 0);

                        return date >= minDate
                      }}
                      onOpen={() => {
                        const today = new Date();
                        const minDate = new Date();
                        minDate.setFullYear(today.getFullYear() - 18);

                        if (!addForm.values.dob) {
                          addForm.setFieldValue("dob", minDate);
                        }
                      }}
                    />
                    <CustomError name="dob" form={addForm} className="text-danger d-flex text-left" />
                  </div>
                  {/* specialization */}
                  <div className="col-md-6 text-center form-group">
                    <label className="text-left d-flex">
                      {t("Specialization")}:
                      <span className="requirestar">*</span>
                    </label>
                    {/* <select className="form-control form-select cp" name='specialization' value={addForm?.values?.specialization} onChange={addForm.handleChange}>
                      <option value={""}>{t("Select")}</option>
                      {specialization && specialization?.length > 0 && specialization?.map((item, index) => { return (<option key={index} value={item._id}>{capitalizeFirstLetter(item.title)}</option>) })}
                    </select> */}
                    {/* <CustomMultiSelect data={specializationData} form={addForm} overFlowVisibleOptions={2} name='specialization' /> */}
                    <TagPicker
                      data={specializationData}
                      defaultValue={addForm.values.specialization}
                      className="w-100 rsuite-input"
                      onChange={(e) => addForm.setFieldValue("specialization", e)}
                      cleanable={false}
                      value={addForm.values.specialization}
                    />
                    {addForm.touched.specialization && addForm.errors.specialization ? (
                      <div className="text-danger d-flex text-left">{t(addForm.errors.specialization)}</div>
                    ) : null}
                  </div>
                  {/* Centers */}
                  {/* <div className="col-md-6 text-center form-group">
                    <label className="text-left d-flex">
                      Center
                      <span className="requirestar">*</span>
                    </label>
                    <select className="form-control form-select cp" name='center' value={addForm?.values?.center} onChange={addForm.handleChange}>
                      <option value={""}>{t("Select")}</option>
                      {centers.map((item, index) => { return (<option key={index} value={item._id}>{capitalizeFirstLetter(item.center_name)}{item.city ? ` (${capitalizeFirstLetter(item.city)})` : ''}</option>) })}
                    </select>
                    {addForm.touched.center && addForm.errors.center ? (
                      <div className="text-danger d-flex text-left">{t(addForm.errors.center)}</div>
                    ) : null}
                  </div> */}
                  <div className="col-md-6 text-center form-group">
                    <label className="text-left d-flex">
                      Centre:
                      <span className="requirestar">*</span>
                    </label>

                    <Select
                      className="cp"
                      name="center"
                      options={centerOptions}
                      value={centerOptions.find(option => option.value === addForm.values.center)}
                      onChange={selectedOption => addForm.setFieldValue('center', selectedOption?.value)}
                      onBlur={() => addForm.setFieldTouched('center', true)}
                      placeholder={t("Select")}
                      isSearchable={true}
                      noOptionsMessage={() => t("No centres found")}
                    />

                    {addForm.touched.center && addForm.errors.center ? (
                      <div className="text-danger d-flex text-left">{t(addForm.errors.center)}</div>
                    ) : null}
                  </div>
                  <div className="col-lg-6 text-center form-group">
                    <label className="text-left d-flex">
                      {t("Consultation Charge")}:
                      <span className="requirestar">*</span>
                    </label>
                    <input
                      type="number"
                      className="form-control"
                      placeholder={t("Enter consultation charge")}
                      name="consultation_charge"
                      value={addForm?.values?.consultation_charge}
                      onChange={addForm.handleChange}
                      onBlur={addForm.handleBlur}
                    />
                    <span className="text-danger d-flex text-left">
                      <CustomError name="consultation_charge" form={addForm} className="text-danger" />
                    </span>
                  </div>
                  <div className="col-lg-3 text-center form-group">
                    <label className="text-left d-flex">
                      {t("Experience(Years)")}:
                      <span className="requirestar">*</span>
                    </label>
                    <input
                      type="number"
                      className="form-control"
                      placeholder={t("Enter experience(years)")}
                      name="experience_years"
                      value={addForm?.values?.experience_years}
                      onChange={addForm.handleChange}
                      onBlur={addForm.handleBlur}
                    />
                    <span className="text-danger d-flex text-left">
                      <CustomError name="experience_years" form={addForm} className="text-danger" />
                    </span>
                  </div>
                  <div className="col-lg-3 text-center form-group">
                    <label className="text-left d-flex">
                      {t("Experience(Months)")}:
                      <span className="requirestar">*</span>
                    </label>
                    <input
                      type="number"
                      className="form-control"
                      placeholder={t("Enter experience(months)")}
                      name="experience_months"
                      value={addForm?.values?.experience_months}
                      onChange={addForm.handleChange}
                      onBlur={addForm.handleBlur}
                    />
                    <span className="text-danger d-flex text-left">
                      <CustomError name="experience_months" form={addForm} className="text-danger" />
                    </span>
                  </div>
                  <div className="col-lg-6 text-center form-group">
                    <label className="text-left d-flex">
                      {t("Qualification 1")}:
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder={t("Enter qualification 1")}
                      name="qualification1"
                      value={addForm?.values?.qualification1}
                      onChange={addForm.handleChange}
                      onBlur={addForm.handleBlur}
                    />
                    {/* <span className="text-danger d-flex text-left">
                      <CustomError name="experience" form={addForm} className="text-danger" />
                    </span> */}
                  </div>
                  <div className="col-lg-6 text-center form-group">
                    <label className="text-left d-flex">
                      {t("Institute 1")}:
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder={t("Enter institute 1")}
                      name="institute1"
                      value={addForm?.values?.institute1}
                      onChange={addForm.handleChange}
                      onBlur={addForm.handleBlur}
                    />
                    {/* <span className="text-danger d-flex text-left">
                      <CustomError name="experience" form={addForm} className="text-danger" />
                    </span> */}
                  </div>
                  <div className="col-lg-6 text-center form-group">
                    <label className="text-left d-flex">
                      {t("Qualification 2")}:
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder={t("Enter qualification 2")}
                      name="qualification2"
                      value={addForm?.values?.qualification2}
                      onChange={addForm.handleChange}
                      onBlur={addForm.handleBlur}
                    />
                    {/* <span className="text-danger d-flex text-left">
                      <CustomError name="experience" form={addForm} className="text-danger" />
                    </span> */}
                  </div>
                  <div className="col-lg-6 text-center form-group">
                    <label className="text-left d-flex">
                      {t("Institute 2")}:
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder={t("Enter institute 2")}
                      name="institute2"
                      value={addForm?.values?.institute2}
                      onChange={addForm.handleChange}
                      onBlur={addForm.handleBlur}
                    />
                    {/* <span className="text-danger d-flex text-left">
                      <CustomError name="experience" form={addForm} className="text-danger" />
                    </span> */}
                  </div>
                  {/* timing */}
                  <div className="col-md-6">
                    <div className="row">
                      <div className="col-md-12">
                      </div>
                      <div className="col-md-6">
                        <label className="text-left d-flex">
                          Start Time:
                          <span className="requirestar">*</span>
                        </label>
                        <div className="mb-3">
                          <DatePicker
                            classPrefix="restaurant"
                            placement="autoVertical"
                            format="HH:mm"
                            cleanable={false}
                            editable={true}
                            name="openingTime"
                            onChange={handleStartTimeChange}
                            value={getDateWithTime(addForm.values.startTime)}
                            onBlur={addForm.handleBlur}
                            hideMinutes={(minute) => minute % 15 !== 0}
                          />
                          <CustomError name="startTime" form={addForm} className="text-danger" />
                          {/* {addForm.touched.startTime && addForm.errors.startTime ? (
                            <div className="text-danger d-flex text-left">{t(addForm.errors.startTime)}</div>
                          ) : null} */}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <label className="text-left d-flex">
                          End Time:
                          <span className="requirestar">*</span>
                        </label>
                        <div className="mb-3">
                          <DatePicker
                            classPrefix="restaurant"
                            placement="autoVertical"
                            format="HH:mm"
                            cleanable={false}
                            editable={true}
                            name="closingTime"
                            onChange={handleEndTimeChange}
                            value={getDateWithTime(addForm.values.endTime)}
                            hideMinutes={(minute) => minute % 15 !== 0}
                          />
                          <CustomError name="endTime" form={addForm} className="text-danger" />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-lg-6 text-center form-group"></div>
                  <div className="col-lg-6 text-center form-group">
                    <label htmlFor="document" className="text-left d-flex">
                      {t("Document")}:
                      {" "}
                      <Whisper
                        placement="top"
                        controlId="control-id-hover"
                        trigger="hover"
                        speaker={
                          <Tooltip>
                            {t("Upload document")}
                          </Tooltip>
                        }
                      >
                        <span className="field-more-info mt-1 ms-1 cp">
                          ?
                        </span>
                      </Whisper>
                    </label>
                    <input
                      className="form-control imgInput"
                      id="document"
                      name="document"
                      accept=".pdf,.doc,.docx,.xls,.xlsx,.csv,.txt,.rtf,.odt,.ppt,.pptx"
                      type="file"
                      onChange={(event) => {
                        addForm.setFieldValue(
                          "document",
                          event.target.files[0] || ""
                        );
                      }}
                    />
                    <span className="text-danger d-flex text-left">
                      <CustomError name="document" form={addForm} />
                    </span>
                  </div>

                  {/* submission buttons */}
                  <div className="mt-5">
                    <button
                      className="btn btn-info mr-2"
                      type="submit"
                      disabled={submitted ? true : null}
                    >
                      <i className="ace-icon fa fa-check bigger-110 mx-1"></i>
                      {t("admin.button.btn_submit")}
                    </button>
                    <button
                      className="btn ripple btn-secondary"
                      type="button"
                      disabled={submitted ? true : null}
                      onClick={() => navigate(-1)}
                    >
                      <i className="ace-icon fa fa-times bigger-110 mx-1"></i>
                      {t("admin.button.btn_cancel")}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </form>
    </>
  );
};

export default UsersAdd;